import React, { useEffect, useState } from 'react'
import audio from '../audios/sample_audio_1.mp3'
import listeningMusic from '../assets/green/listening_music_white_bg.png'
import musicPlay from "../assets/green/play2.png";
import musicPause from "../assets/green/pause2.png";
import { useRef } from 'react';

function AudioComponent({name , link, refHandler , parentRef}) {

    const audioRef = useRef(null);
    const [isPlaying , setIsPlaying] = useState(false)


    const onClickHandler = (currentRef , parentRef) => {
        refHandler(currentRef)
        console.log(isPlaying, "isplay");
        if (isPlaying && currentRef == parentRef) {
          currentRef.current.pause();
          setIsPlaying(false);
        } else {
          currentRef.current.play();
          setIsPlaying(true);
        }
      };
  return (
    <div className={`border-2 border-black  bg-white min-w-[20rem] mr-4  h-auto block mx-auto rounded-md py-2`}>

    <div className='flex justify-between items-center'>
      <img className='w-8 float-left ml-2' src={listeningMusic} />

      <div className='font-bold'>{name}</div>

      <audio ref={audioRef} src={link} ></audio>
        <img
          id="player"
          src={isPlaying && audioRef == parentRef ? musicPause : musicPlay}
          className="mr-2"
          onClick={() => onClickHandler(audioRef , parentRef)}
          style={{ width: "35px", height: "35px" }}
        />
    </div>


      </div>
  )
}

export default AudioComponent